import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { logger } from '../../../common/utils/logger';

// When an admin types in a query but no bookmark exists and is shown the add bookmark component (different than modal)
export const onAddBookmarkShown: (props: { query: string }) => AnalyticsEventPayload = (props: {
	query: string;
}): AnalyticsEventPayload => {
	try {
		const { query } = props;
		return {
			action: 'shown',
			actionSubject: 'aiSearchAddBookmark',
			eventType: 'track',
			nonPrivacySafeAttributes: {
				query,
			},
		};
	} catch (error) {
		logger.error({
			feature: 'bookmarks',
			element: 'container',
			operation: 'build-analytics',
			category: 'invariant',
			telemetryOnly: true,
			error,
			functionName: 'onAddBookmarkShown',
		});
		return {};
	}
};
